import React from 'react';
import { Typography, TextArea, HelperText } from '@scale/scaleui';
import { SmsCommunication } from '@scale/shared-types';

interface SmsMessageComponentProps {
  smsCommunication: Partial<SmsCommunication>;
  updateSmsCommunicationFields: (fields: { body: string }) => void;
  setTested: (tested: boolean) => void;
  smsCommunicationId: string | null;
  validateMsg: (text: string, fieldType: string) => void;
}

const SmsMessageComponent: React.FC<SmsMessageComponentProps> = ({
  smsCommunication,
  updateSmsCommunicationFields,
  setTested,
  smsCommunicationId,
  validateMsg,
}) => (
  <div className="gap-1">
    <div className="flex gap-5">
      <div className="flex-1">
        <Typography.Paragraph2 className="text-neutral-800 pb-1">SMS Message</Typography.Paragraph2>
        <TextArea
          className="w-full"
          placeholder="Enter the SMS message. Example: 'Your contribution is outstanding. Keep up the good work!'"
          helperText="max 290 characters"
          initialResize
          dynamic
          resizable
          maxLength={290} // (320 - 30) for potentially adding "Text STOP to cancel." and "Outlier: "
          value={smsCommunication.body}
          onChange={e => {
            updateSmsCommunicationFields({ body: e.target.value });
            validateMsg(e.target.value, 'body');
            setTested(false);
          }}
          disabled={!!smsCommunicationId}
        />
      </div>
      <div className="flex-1">
        <Typography.Paragraph2 className="text-neutral-800 pb-1">Preview:</Typography.Paragraph2>
        <div
          className="text-neutral-600 bg-neutral-50 rounded p-2"
          dangerouslySetInnerHTML={{
            __html: smsCommunication.body
              ? `Outlier: ${
                  smsCommunication.body?.replace(/\n/g, '<br />') ?? ''
                }<br />Text STOP to cancel.`
              : '<br />',
          }}
        />
        <HelperText className="text-neutral-600 pt-2">
          Note: "Outlier: " or "Remotasks: " will be added to the beginning of the SMS depending on
          the user account type; "Text STOP to cancel." will be added to the end if this is the
          first SMS sent to the recipient.
        </HelperText>
      </div>
    </div>
  </div>
);

export default SmsMessageComponent;
